
import React from 'react';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from '@/components/ui/breadcrumb';
import { HomeIcon, ChevronRight } from 'lucide-react';
import { SECTIONS } from '@/constants/application';

interface ApplicationBreadcrumbProps {
  currentSection: number;
}

export const ApplicationBreadcrumb: React.FC<ApplicationBreadcrumbProps> = ({ currentSection }) => {
  const sectionTitle = SECTIONS[currentSection] || 'Unknown Section';
  
  return (
    <Breadcrumb>
      <BreadcrumbList className="bg-white px-3 py-2 rounded-md shadow-sm border border-gray-100">
        <BreadcrumbItem>
          <BreadcrumbLink 
            href="/" 
            className="text-primary font-medium flex items-center hover:text-primary/80 transition-colors"
          >
            <HomeIcon className="h-3.5 w-3.5 mr-1" />
            <span>Home</span>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator>
          <ChevronRight className="h-3.5 w-3.5 text-gray-400" />
        </BreadcrumbSeparator>
        <BreadcrumbItem>
          <BreadcrumbLink 
            href="/application" 
            className="text-primary/90 font-medium hover:text-primary/80 transition-colors"
          >
            Application
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator>
          <ChevronRight className="h-3.5 w-3.5 text-gray-400" />
        </BreadcrumbSeparator>
        <BreadcrumbItem>
          <span className="font-medium text-gray-700">{sectionTitle}</span>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
};
